module.exports = __webpack_public_path__ + "static/img/submit.9ba1dd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/submit.png
// module id = tUGb
// module chunks = 128